import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

type Props = {
  cancelButton: React.ReactNode
  confirmCb: () => void
}

// Asked before the page-selection window of a finished crawl closes: the crawled pages
// live only in that window, and closing it throws minutes of crawling away (OCT-5313).
export const DiscardCrawl: React.FC<Props> = ({ cancelButton, confirmCb }) => {
  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">Discard crawl?</div>

      <div className="System-dialog__description">
        <p>The crawled pages will be lost.</p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="Discard"
            onClick={confirmCb}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}
